module.exports = __webpack_public_path__ + "fonts/roboto-v27-latin-ext_latin-500.3dc2c79.woff";